export const tintColorLight = '#2cae35';
export const backGroundLight = '#f2f3f7';
export const normalTextColor = '#333333';
export const subTextColor = '#878484';
export const accentColor = '#f57a4c';
export const subColorLight = '#94c515';
export const warningRed = '#eb6565';
